import {
  reactive,
  toRefs,
  onMounted,
  watch,
  getCurrentInstance,
} from '@vue/composition-api';
import { eventTracker } from 'partners-widget-core';

import { useBasketContext } from '@/compositions/basket/basketStorage';

const useCoupon = ({ isFetchBasket = true }) => {
  const basketContext = useBasketContext();
  const { emit } = getCurrentInstance();

  const localState = reactive({
    valueCoupon: '',
    descriptionCoupon: '',
    applyingCouponError: false,
    applyingCouponSuccess: false,
    applyingCoupon: false,
    errorText: 'Промокод не найден',
    isFirstRender: true,
  });

  const resetFlags = () => {
    localState.applyingCouponError = false;
    localState.applyingCouponSuccess = false;
    localState.applyingCoupon = false;
  };

  const resetErrorText = () => {
    localState.errorText = 'Промокод не найден';
  };

  const removePromoCode = async () => new Promise((resolve) => {
    resetFlags();
    resetErrorText();
    localState.applyingCoupon = true;

    basketContext.removePromoCode(localState.valueCoupon)
      .then(() => {
        localState.descriptionCoupon = '';
        resolve();
      })
      .catch((error) => {
        localState.errorText = error.message;
        localState.applyingCouponError = true;
      })
      .finally(async () => {
        localState.applyingCoupon = false;
        localState.valueCoupon = '';

        let result;

        if (isFetchBasket) {
          result = await basketContext.fetchBasket();
        }

        eventTracker.dispatchEvent('remove-promocode', result);
      });
  });

  const applyPromoCode = async () => new Promise((resolve) => {
    resetFlags();
    resetErrorText();

    if (localState.valueCoupon === '') {
      localState.errorText = 'Промокод не должен быть пустым';
      localState.applyingCouponError = true;
    } else {
      localState.applyingCoupon = true;

      basketContext.applyPromoCode(localState.valueCoupon)
        .then((data) => {
          localState.applyingCouponSuccess = true;
          localState.descriptionCoupon = data.description;
          resolve(data);
        })
        .catch((error) => {
          if (error?.message === 'Купон не найден') localState.errorText = 'Промокод не найден';
          else localState.errorText = error.message;
          localState.applyingCouponError = true;
        })
        .finally(async () => {
          localState.applyingCoupon = false;

          let result;

          if (isFetchBasket) {
            result = await basketContext.fetchBasket();
          }

          eventTracker.dispatchEvent('add-promocode', result);
        });
    }
  });

  const setPromoCodeDefault = (promoCode) => {
    if (promoCode?.code) {
      localState.valueCoupon = promoCode.code;
      localState.descriptionCoupon = promoCode.description;
      localState.applyingCouponSuccess = true;
      if (localState.isFirstRender) {
        emit('couponChanged', localState.valueCoupon);
        localState.isFirstRender = false;
      }
    }
  };

  onMounted(() => {
    setPromoCodeDefault(basketContext.basketPromoCode.value);
  });

  watch(
    () => basketContext.basketPromoCode.value,
    (val) => {
      setPromoCodeDefault(val);
    },
    { immediate: false },
  );

  return {
    ...toRefs(localState),
    removePromoCode,
    applyPromoCode,
  };
};

export default useCoupon;
